// extracted by css-extract-rspack-plugin
export default {"AgoTimestampLink":"Ago-module__AgoTimestampLink__Wrukn","timestampText":"Ago-module__timestampText__OTeZJ"};